import type { ChartDataDigest } from './turn-outcome-digest';

export type GlobalAiChartPreviewPhase =
  | 'idle'
  | 'mounting'
  | 'applying_filters'
  | 'filters_ready'
  | 'fetching'
  | 'success'
  | 'error';

export type GlobalAiChartPreviewDataBranch = 'snowflake' | 'multi' | 'main';

export type GlobalAiChartPreviewRuntimeSnapshot = {
  phase: GlobalAiChartPreviewPhase;
  filterApplyError?: string;
  /** Short line for blocked / in-flight data layer (metric, branch, taxonomy, urql status). */
  providerDiagnostics?: string;
  dataProviderBranch?: GlobalAiChartPreviewDataBranch;
  lastDataProviderStatus?: string;
  timeline?: GlobalAiChartPreviewTimelineEvent[];
  /** Compact data digest for narration; set once provider data settles. */
  dataDigest?: ChartDataDigest;
  /** Original user prompt for this turn (for the narration request). */
  narrationPrompt?: string;
  /**
   * Narration lifecycle for the line under the chart: 'streaming' renders a
   * skeleton until text arrives, 'shown' keeps the final text, 'failed'
   * renders nothing (fail-silent).
   */
  narrationStatus?: 'streaming' | 'shown' | 'failed';
  /** Accumulated narration text (replaces the skeleton as it streams in). */
  narrationText?: string;
};

export type GlobalAiChartPreviewTimelineEvent = {
  atMs: number;
  event: string;
};

export type GlobalAiPipelineTimelineEvent = {
  atMs: number;
  event: string;
};

export function createIdleChartPreviewRuntime(): GlobalAiChartPreviewRuntimeSnapshot {
  return { phase: 'idle' };
}
